if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._slides = null;
        this._viewport = null;
        this._navPrev = null;
        this._navNext = null;

        this._onPrev = this._onPrev.bind(this);
        this._onNext = this._onNext.bind(this);
        this._onKey = this._onKey.bind(this);
      }

      hide() {
        try {
          this.removeEventListener('keydown', this._onKey);
          if (this._navPrev) this._navPrev.removeEventListener('click', this._onPrev);
          if (this._navNext) this._navNext.removeEventListener('click', this._onNext);
        } catch (e) {}

        this._slides = null;
        this._viewport = null;
        this._navPrev = null;
        this._navNext = null;

        super.hide();
      }

      show(opener) {
        super.show(opener);

        if (!this.classList.contains('product-media-modal--lightbox')) {
          this._legacyShowActiveMedia(opener);
          return;
        }

        this.openedBy = opener;
        this._initLightbox();
        this.showActiveMedia();

        this.addEventListener('keydown', this._onKey);
      }

      _legacyShowActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy && this.openedBy.getAttribute ? this.openedBy.getAttribute('data-media-id') : ''}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy && this.openedBy.getAttribute ? this.openedBy.getAttribute('data-media-id') : ''}"]`
        );
        const activeMediaTemplate = activeMedia && activeMedia.querySelector ? activeMedia.querySelector('template') : null;
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (activeMedia) activeMedia.classList.add('active');
        if (activeMedia && activeMedia.scrollIntoView) activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        try {
          if (activeMedia && container) {
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
          }
        } catch (e) {}

        if (
          activeMedia &&
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          try { activeMedia.loadContent(); } catch (e) {}
        }
      }

      /* --- Lightbox --- */
      _initLightbox() {
        if (this._slides) return;
        this._slides   = Array.from(this.querySelectorAll('.modal-media-item'));
        this._viewport = this.querySelector('.product-media-modal__viewport');
        this._navPrev  = this.querySelector('.product-media-modal__prev');
        this._navNext  = this.querySelector('.product-media-modal__next');

        if (this._navPrev) this._navPrev.addEventListener('click', this._onPrev);
        if (this._navNext) this._navNext.addEventListener('click', this._onNext);
      }

      showActiveMedia() {
        if (!this.classList.contains('product-media-modal--lightbox')) {
          return this._legacyShowActiveMedia();
        }
        if (!this._slides || this._slides.length === 0) this._initLightbox();

        const opener = this.openedBy;
        let mediaId = opener && opener.getAttribute ? opener.getAttribute('data-media-id') : null;
        let idx = 0;

        if (mediaId && this._slides.length) {
          idx = this._slides.findIndex(slide => slide.getAttribute('data-media-id') === mediaId);
          if (idx === -1) idx = 0;
        }
        this.goTo(idx);
      }

      goTo(index) {
        if (!this._slides || !this._slides[index]) return;
        const target = this._slides[index];

        this._slides.forEach(s => s.classList.remove('active'));
        target.classList.add('active');

        try {
          target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } catch (e) {
          if (this._viewport) {
            this._viewport.scrollLeft =
              target.offsetLeft - (this._viewport.clientWidth - target.clientWidth) / 2;
          }
        }

        const deferred = target.querySelector('deferred-media, .deferred-media');
        if (deferred && typeof deferred.loadContent === 'function') {
          try { deferred.loadContent(); } catch (e) {}
        }

        this._currentIndex = index;
      }

      _onPrev() {
        const i = (typeof this._currentIndex === 'number') ? this._currentIndex - 1 : 0;
        this.goTo(Math.max(0, i));
      }

      _onNext() {
        const max = this._slides ? this._slides.length - 1 : 0;
        const i = (typeof this._currentIndex === 'number') ? this._currentIndex + 1 : 0;
        this.goTo(Math.min(max, i));
      }

      _onKey(e) {
        if (e.key === 'ArrowLeft')  this._onPrev();
        if (e.key === 'ArrowRight') this._onNext();
        // Jangan handle Escape di sini — biarkan global.js yang menutup modal
      }
    }
  );
}
